import { Schema, defineTable } from 'squid';
export const jobWorkDetailsTable = defineTable('job_work_details', {
    job_id: Schema.String,
    type: Schema.String,
    details: Schema.Any,
});
